import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ClassManagement from './ClassManagement.jsx';
import AttendanceTracking from './AttendanceTracking.jsx';
import './ClassesHub.css';

// One "Classes & Attendance" hub that replaced the separate Class Management and
// Attendance nav items — they go hand in hand (manage the class, then take its
// attendance). Each tab renders its existing component in `embedded` mode so the
// hub owns the single page heading.
const TABS = [
  { key: 'classes', label: 'Classes', icon: '📚' },
  { key: 'attendance', label: 'Attendance', icon: '✅' },
];

function ClassesHub({ initialTab = 'classes' }) {
  const [params, setParams] = useSearchParams();
  const requested = params.get('tab') || initialTab;
  const active = TABS.some(t => t.key === requested) ? requested : 'classes';

  const setTab = (key) => setParams(key === 'classes' ? {} : { tab: key }, { replace: true });

  return (
    <div className="ch-wrap">
      <div className="ch-head">
        <h1>📚 Classes &amp; Attendance</h1>
      </div>

      <div className="ch-tabs" role="tablist">
        {TABS.map(t => (
          <button
            key={t.key}
            role="tab"
            aria-selected={active === t.key}
            className={`ch-tab ${active === t.key ? 'active' : ''}`}
            onClick={() => setTab(t.key)}
          >
            <span className="ch-tab-ico">{t.icon}</span>
            {t.label}
          </button>
        ))}
      </div>

      <div className="ch-panel">
        {active === 'classes' && <ClassManagement embedded />}
        {active === 'attendance' && <AttendanceTracking embedded />}
      </div>
    </div>
  );
}

export default ClassesHub;
